import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import api from "@/lib/api";

// Member dashboard header pill: shown only when upcoming volunteer dates still have open spots.
export default function VolunteerBadge() {
  const [open, setOpen] = useState(0);
  useEffect(() => { api.get("/volunteers/summary").then(({ data }) => setOpen(data.open_spots || 0)).catch(() => {}); }, []);
  if (!open) return null;
  return (
    <Link to="/member/schedule?tab=volunteers" data-testid="member-volunteer-badge"
      className="inline-flex items-center gap-2 rounded-full border border-teal-200 bg-teal-50 py-1 pl-1 pr-3.5 text-sm font-semibold text-teal-700 shadow-sm transition-colors hover:bg-teal-100 animate-fade-in-up">
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-teal-100"><HeartHandshake className="h-4 w-4" /></span>
      <span data-testid="member-volunteer-badge-count">Volunteer · {open} open spot{open === 1 ? "" : "s"}</span>
    </Link>
  );
}
